import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class InitSwiper {
  constructor() {
    const carousel = new Swiper('.js-carousel', {
      loop: true,
      loopAdditionalSlides: 2,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        641: {
          centeredSlides: false,
          slidesPerView: 3,
        }
      }
    });

    const carouselCareer = new Swiper('.js-carousel-career', {
      loop: true,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          current = current.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          });
          return '<span class="swiper-pagination-current">'+ current +'</span>' + '<span class="swiper-pagination-total">'+ total +'</span>';
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        641: {
          slidesPerView: 'auto',
        }
      }
    });

    const gallery = new Swiper('.js-gallery', {
      // centeredSlides: true,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        641: {
          slidesPerView: 'auto',
        }
      }
    });

    const sliders = document.querySelectorAll('.js-galleryWithTitle');
    sliders.forEach((slider) => {
      const galleryTitle = new Swiper(slider.nextElementSibling, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
      });

      const galleryWithTitle = new Swiper(slider, {
        centeredSlides: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: galleryTitle
        },
        breakpoints: {
          641: {
            slidesPerView: 3,
          }
        },
      });

    });
  }
}
window.addEventListener("DOMContentLoaded", () => {
  new InitSwiper();
});
